import { cn } from "@/lib/utils";
import { Button } from "@/toggle-ui-kit/button";

interface NumberBadgeProps {
  number: number;
}

const NumberBadge = ({ number }: NumberBadgeProps) => (
  <div className="flex items-center justify-center w-6 h-6 rounded-full bg-label-normal text-white text-xs font-medium">
    {number}
  </div>
);

export interface DsdCardWrapperProps {
  /** 카드 번호 (1: 기준, 2: 비교 대상) */
  number: 1 | 2;
  /** 카드 제목 */
  title: string;
  /** 하단 버튼 텍스트 (없으면 버튼 숨김) */
  buttonText?: string;
  /** 버튼 클릭 핸들러 */
  onButtonClick?: () => void;
  /** 카드 컨텐츠 */
  children: React.ReactNode;
  className?: string;
}

export const DsdCardWrapper = ({
  number,
  title,
  buttonText,
  onButtonClick,
  children,
  className,
}: DsdCardWrapperProps) => {
  return (
    <div
      className={cn(
        "flex flex-col gap-6 px-[19px] py-[23px] bg-white border border-line-normal rounded-2xl max-w-[560px] min-w-[316px]",
        className,
      )}
    >
      {/* 헤더: 넘버 뱃지 + 제목 */}
      <div className="flex items-center gap-2">
        <NumberBadge number={number} />
        <span className="headline-2-semibold text-label-normal">{title}</span>
      </div>

      {/* 컨텐츠 영역 */}
      {children}

      {/* 하단 버튼 (선택적) */}
      {buttonText && (
        <div className="flex justify-end">
          <Button variant="outlined" size={32} onClick={onButtonClick}>
            {buttonText}
          </Button>
        </div>
      )}
    </div>
  );
};
